import { createAsyncThunk } from "@reduxjs/toolkit";
import { generateDriveTimeArea as generateDriveTimeAreaRequest } from "api/generateDriveTimeArea";
import { IDriveTimeGeometry } from "features/MarketAreas/types";

export type TGenerateDriveTimeAreaArgs = {
  center: { lat: number; lng: number };
  minutes: number;
};

export const generateDriveTimeArea = createAsyncThunk<
  IDriveTimeGeometry,
  TGenerateDriveTimeAreaArgs
>("marketAreaDriveTime/generate", ({ center, minutes }, { signal }) =>
  generateDriveTimeAreaRequest(
    {
      center: { latitude: center.lat, longitude: center.lng },
      driveTimeMinutes: minutes,
    },
    signal
  )
);
